module.exports = __webpack_public_path__ + "static/RMV-3395a67a41c455aacf55dfb8f55b22de.png";